module.exports = __webpack_public_path__ + "img/iMac_Desk_Scorecard_Row.f287c1ed.jpg";